import { useState, useEffect } from "react";
import styled from "styled-components";
import ModalUpdatePlan from "./modalUpdatePlan";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useNavigate } from "react-router-dom";

const Title = styled.div`
    position: relative;
    width: 100%;
    min-height: 56px;
    background-color: #463694;
    z-index: 100;
    display: flex;
    align-items: center;
    padding: 8px 40px;

    @media (max-width: 700px) {
        flex-direction: column;
        gap: 16px;
        max-height: 156px;
    }
`;

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 8px;

    @media (max-width: 700px) {
        flex-direction: column;
        gap: 16px;
    }
`;

const ContainerText = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;

    @media (max-width: 700px) {
        svg {
            display: none;
        }
    }
`;

const Text = styled.span`
    color: #fff;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: -0.56px;

    @media (max-width: 700px) {
        font-size: 12px;
    }
`;

const HighlightedText = styled.span`
    color: #fff;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
    letter-spacing: -0.56px;

    @media (max-width: 700px) {
        font-size: 12px;
        text-align: center;
    }
`;

const ButtonNewPlan = styled.button`
    display: flex;
    height: 40px;
    padding: 12px 16px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    background: #ffcf3d;
    border: none;
    cursor: pointer;

    @media (max-width: 700px) {
        width: 100%;
    }
`;

const ButtonText = styled.span`
    color: var(--Dark-Pure, #000);
    text-align: center;
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    text-transform: uppercase;
`;

const ToastUpdatePlan = ({ currentFreePlan, enablePayments, profile }) => {
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        const hasSeenUpdatePlanModal = localStorage.getItem(
            "hasSeenUpdatePlanModal"
        );

        if (!hasSeenUpdatePlanModal) {
            setShowModal(true);
            localStorage.setItem("hasSeenUpdatePlanModal", "true");
        }
    }, []);

    const HighlightedTextValue = () => {
        if (!enablePayments && !profile?.permissions?.plans) {
            return "";
        }
        if (currentFreePlan) {
            return "Novos preços no Zag:";
        } else {
            return "Nova política de preços 2026:";
        }
    };

    const TextValue = () => {
        if (currentFreePlan || !enablePayments || !profile?.permissions?.plans) {
            return "Conheça nossos novos planos para 2026 e continue descomplicando os reembolsos corporativos da sua empresa.";
        } else {
            return "Seu atual plano Zag foi descontinuado, atualize-o ainda este mês e evite bloqueios.";
        }
    };

    return (
        <>
            {enablePayments !== null && currentFreePlan !== null && profile?.permissions?.plans && (
                <>
                    <Title>
                        <Container>
                            <ContainerText>
                                <ErrorOutlineIcon
                                    fontSize="small"
                                    style={{ fill: "#FFF" }}
                                />
                                <HighlightedText>
                                    {HighlightedTextValue()}{" "}
                                    <Text>{TextValue()}</Text>
                                </HighlightedText>
                            </ContainerText>
                            <ButtonNewPlan
                                onClick={() => {
                                    if (!enablePayments && !profile?.permissions?.plans) {
                                        window.open(
                                            "https://www.zagapp.com.br/#precos",
                                            "_blank"
                                        );
                                        return;
                                    }
                                    if (currentFreePlan) {
                                        setShowModal(true);
                                    } else {
                                        navigate("/settings?openPlans=true");
                                    }
                                }}
                            >
                                <ButtonText>
                                    {currentFreePlan
                                        ? "Conhecer os novos planos"
                                        : "Escolher novo plano"}
                                </ButtonText>
                            </ButtonNewPlan>
                        </Container>
                    </Title>
                    {enablePayments && profile?.permissions?.plans && (
                        <ModalUpdatePlan
                            showModal={showModal}
                            setShowModal={setShowModal}
                            currentFreePlan={currentFreePlan}
                        />
                    )}
                </>
            )}
        </>
    );
};

export default ToastUpdatePlan;
